import { DelightedProperties } from '@interfaces/delighted-properties.interface';
import { DelightedSubProperties } from '@interfaces/delighted-sub-properties.interface';

export class DelightedCombinedProperties {
  properties: DelightedSubProperties;
  createdAt: string;
  name: string;

  constructor(properties: DelightedProperties, sessionStorage: Storage) {
    Object.assign(this, properties);
    this.setCreatedAt(sessionStorage);
  }

  private setCreatedAt(sessionStorage): void {
    const sessionStartTime = sessionStorage.getItem('sessionStartTime');
    if (sessionStartTime) {
      this.createdAt = new Date(sessionStartTime).toISOString();
    }
  }
}
